module.exports = __webpack_public_path__ + "media/images/tmp/slide3-46c97ef77c25d585741f824a7e7e8bdc.jpg";